import { Chip, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";
import EditIcon from "@mui/icons-material/Edit";

export default () => (
	<CssColumnGrid columns={4}>
		<Text semiBold text="normal" />
		<Text semiBold text="overflow with long text" />
		<Text semiBold text="overflow with icon" />
		<Text semiBold text="overflow with long text and deletable" />
		<Chip
			label="normal"
		/>
		<Chip
			label="overflow with long text"
			style={{ maxWidth: 80 }}
			variant="outlined"
		/>
		<Chip
			icon={(<EditIcon />)}
			label="overflow with icon"
			style={{ maxWidth: 80 }}
			variant="outlined"
		/>
		<Chip
			label="overflow with long text and deletable"
			onDelete={() => { console.log("clickable"); }}
			style={{ maxWidth: 80 }}
			variant="outlined"
		/>
	</CssColumnGrid>
);